import { useColorScheme } from '@mui/material/styles';
import { useAppSelector } from '../redux/store';

interface PortalLogoProps {
	height?: number;
	alt?: string;
}

export default function PortalLogo({ height = 50, alt = 'Portal Logo' }: PortalLogoProps) {
	const { mode } = useColorScheme(); // "light" | "dark" | "system"
	const { data: brand, loading } = useAppSelector(state => state.brand);

	const logo = mode === 'dark' ? brand?.logoDark : brand?.logoLight;

	const fallbackLight = '/logos/logo-infinite1-nobg.png';
	const fallbackDark = '/logos/logo-infinite2.png';
	const fallback = mode === 'dark' ? fallbackDark : fallbackLight;

	if (loading) {
		return (
			<div
				style={{
					height,
					width: height * 2,
					background: 'rgba(255,255,255,0.1)',
					borderRadius: 6,
				}}
			/>
		);
	}

	return (
		<img
			src={logo || fallback}
			alt={alt}
			height={height}
			style={{ maxWidth: '100%', objectFit: 'contain' }}
			onError={e => {
				(e.target as HTMLImageElement).src = fallback;
			}}
		/>
	);
}
